import { Button, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addItemToCart,
  decrementCartItemCount,
  ICartItem,
  ICartState,
} from "../../../stateManagement/reducers/cartReducer";
import { IRentalItem } from "../../../stateManagement/reducers/rentalItemsReducer";
import { IRootReducerT } from "../../../stateManagement/reduxStore";
import AnimateButton from "../../@extended/AnimateButton";
import borders from "../../../assets/theme/base/borders";
import { IAuthState } from "../../../stateManagement/reducers/authReducer";
import { useNavigate } from "react-router-dom";

interface IProps {
  openCartModal?: () => void;
  rentalItem: IRentalItem;
  textColor?: string;
}

const SelectionButton: FC<IProps> = ({
  rentalItem,
  openCartModal,
  textColor,
}) => {
  const { cart } = useSelector<IRootReducerT, ICartState>(
    (state) => state.cart,
  );
  const navigate = useNavigate();

  const dispatch = useDispatch<any>();

  const { user } = useSelector<IRootReducerT, IAuthState>(
    (state) => state.auth,
  );

  const cartItem: ICartItem | undefined = cart.items.find(
    (item) => item.rentalItem._id === rentalItem._id,
  );

  return (
    <>
      {!cartItem && (
        <AnimateButton>
          <Button
            variant="contained"
            size="large"
            color="info"
            sx={{
              color: "white !important",
              fontWeight: "700",
              // background: '#111',
              // background: 'linear-gradient(to bottom left, #111, #333, #111)'
              background: "linear-gradient(to top,#2b6e3f, #4caf50)",
              borderRadius: borders.borderRadius.md,
              px: "1rem!important",
              py: ".5rem!important",
            }}
            onClick={() => {
              if (!user) {
                return navigate("/login", { replace: true });
              }

              dispatch(addItemToCart({ rentalItem, count: 1 }));

              if (openCartModal) {
                openCartModal();
              }
            }}
          >
            Add to Cart
          </Button>
        </AnimateButton>
      )}
      {cartItem && (
        <Stack direction="row" alignItems="center" sx={{ width: "100%" }}>
          <AnimateButton>
            <Button
              variant="contained"
              size="large"
              color="info"
              sx={{
                color: "white !important",
                fontWeight: "700",
                // background: 'linear-gradient(to bottom left, #111, #333, #111)'
                background: "linear-gradient(to top, #8b0000, #ff5e57)",
                borderRadius: borders.borderRadius.md,
                px: "1rem!important",
                py: ".5rem!important",
                mr: "auto !important",
                ml: "0 !important",
              }}
              onClick={() => {
                dispatch(
                  decrementCartItemCount({
                    rentalItemId: cartItem.rentalItem._id,
                    count: 1,
                  }),
                );
              }}
            >
              -
            </Button>
          </AnimateButton>
          <Typography
            sx={{
              pl: ".5rem",
              color: textColor ?? "#F5F0E6",
              "&:hover": { color: textColor ?? "#F5F0E6" },
              ml: "auto",
              mr: "0",
              fontWeight: "500",
              fontStyle: "italic",
            }}
          >
            {cartItem.count}
          </Typography>
          <Typography
            sx={{
              pl: ".25rem",
              pr: ".5rem",
              color: textColor ?? "#F5F0E6",
              "&:hover": { color: textColor ?? "#F5F0E6" },
              mr: "auto",
              ml: "0",
              fontStyle: "italic",
              fontWeight: "300",
            }}
          >
            in cart
          </Typography>
          <AnimateButton>
            <Button
              variant="contained"
              size="large"
              color="info"
              sx={{
                color: "white !important",
                fontWeight: "700",
                // background: '#111',
                // background: 'linear-gradient(to bottom left, #111, #333, #111)'
                background: "linear-gradient(to top,#2b6e3f, #4caf50)",
                borderRadius: borders.borderRadius.md,
                px: "1rem!important",
                py: ".5rem!important",
                ml: "auto",
                mr: "0",
              }}
              onClick={() => {
                dispatch(addItemToCart({ rentalItem, count: 1 }));
              }}
            >
              +
            </Button>
          </AnimateButton>
        </Stack>
      )}
    </>
  );
};

export default SelectionButton;
